import { cn } from '../lib/cn.js';

interface LogoProps {
  size?: number;
  className?: string;
}

/**
 * Imza brand mark — renders the actual brand logo SVG.
 * Uses <img> tag pointing to the static SVG file.
 * SVG is vector so it's crisp at any size — explicit width/height
 * style prevents mobile browsers from fuzzy-scaling.
 */
export function Logo({ size = 32, className }: LogoProps) {
  return (
    <img
      src="/logo.svg"
      alt="Imza"
      width={size}
      height={size}
      style={{ width: size, height: size, minWidth: size, minHeight: size }}
      className={cn('flex-shrink-0 rounded-[18%] object-contain', className)}
      draggable={false}
    />
  );
}
